/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { List } from 'antd'
import _ from 'lodash'
import { FilterList, FilterWrapStyle, ListBtnStyle } from '@views/Popup/MatchupFilter/index.style'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON } from '@constants/index'
import { Button } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import { Schema$UserPickMarket } from '@interface/user-pick'
import { EXCEPTIONAL_UNIQUE_ID } from '@v2/constants/common'

export interface SelectEtcMarketTypeProps {
  markets: Schema$UserPickMarket[]
  matchId: number
}

export const EtcMarketFilterList: React.FC<SelectEtcMarketTypeProps> = observer((props) => {
  const { globalStore, userPickStore } = useRootStore()
  const { markets, matchId } = props
  const { selectedEtcMarket } = userPickStore

  const dataSource = [
    { marketName: '전체', marketType: EXCEPTIONAL_UNIQUE_ID.ETC_USER_PICK },
    ...markets,
  ]

  let userPickTotal = 0
  _.forEach(markets, m => userPickTotal += m.userPickCount)

  const onClick = (market: Schema$UserPickMarket): void => {
    userPickStore.setSelectedEtcMarket(market)
    userPickStore.fetchUserPickMatchDetailPackage({
      matchId, reset: true,
    }).catch(console.error)
    globalStore.closeDialog()
  }

  const renderFilterListItem = (row: Schema$UserPickMarket) => {
    let style = {}
    if (row.marketType === selectedEtcMarket?.marketType
      || (!selectedEtcMarket && row.marketType === EXCEPTIONAL_UNIQUE_ID.ETC_USER_PICK)) {
      style = {
        background: 'rgba(37,114,118,.15)',
        border: '1px solid rgba(37,114,118,.5)',
      }
    }
    let label = `${row.marketName} (${row.userPickCount})`
    if (row.marketType === EXCEPTIONAL_UNIQUE_ID.ETC_USER_PICK) {
      label = `전체 (${userPickTotal})`
    }
    return (
      <Button css={ListBtnStyle} onClick={() => onClick(row)} style={style}>
        <List.Item style={{ justifyContent: 'center' }}>
          {label}
        </List.Item>
      </Button>
    )
  }

  const localeAdvEmpty = { emptyText: <AdvEmpty ico={EMPTY_ICON.MATCH_FILTER}/> }

  return (
    <div css={FilterWrapStyle}>
      <List
        className="filter-list"
        css={FilterList}
        // header={header}
        bordered
        dataSource={dataSource}
        renderItem={renderFilterListItem}
        locale={localeAdvEmpty}
      />
    </div>
  )
})
